module.exports = __webpack_public_path__ + "static/media/wide-arrow-up.7e20bb08.png";